// extracted by mini-css-extract-plugin
module.exports = {"priceImpact":"PriceImpact-module--priceImpact--3Ey9d","alert":"PriceImpact-module--alert--3UGTD","number":"PriceImpact-module--number--1Q1j2"};